import { render } from "./share-modal-actions.vue?vue&type=template&id=52f8d983&scoped=true&ts=true"
import script from "./share-modal-actions.vue?vue&type=script&lang=ts"
export * from "./share-modal-actions.vue?vue&type=script&lang=ts"

import "./share-modal-actions.vue?vue&type=style&index=0&id=52f8d983&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f8d983"]])

export default __exports__